
// import Feedbacks from '../Feedbacks/index.vue'
import InnerPageTitle from '../Shared/InnerPageTitle/index.vue'
// import WebSiteCounts from '../Home/WebSiteCounts.vue'
import Personal from '../AboutUs/About1.vue'
import Sponsor from '../Home/Sponsor.vue'

export default {
  components: {
    /* Feedbacks,*/ InnerPageTitle,
    // WebSiteCounts,
    Personal,
    Sponsor,
  },
  data() {
    return {
      st: this.$store.state.settings.contents[this.$i18n.locale],
      abouts: [],
    }
  },
  methods: {
    SET_ABOUT_CONTENT() {
      const arr = []
      for (const key in this.st) {
        if (Object.hasOwnProperty.call(this.st, key)) {
          const element = this.st[key]
          if (key.includes('about'))
            arr.push({
              ...element,
              imagePath:
                element.imagePath === null
                  ? this.$store.state.settings.aboutImg
                  : element.imagePath,
            })
        }
      }
      return arr
    },
  },
  mounted() {
    this.abouts = this.SET_ABOUT_CONTENT()
  },
}
